import React from "react";
import { observer, inject } from "mobx-react";
import * as M from "@material-ui/core";
import FirebaseStore from "../models/Firebase";

const GroupEdit = props => {
  const { $group, $config } = props.store;
  const $firebase = new FirebaseStore();

  React.useEffect(() => {
    $firebase
      .getRespondents({ surveyKey: "oHHAvZZm88LO6QqCeNzd", groupKey: $group.selected._key })
      .then(snapshot => $group.selected.change("respondentsCount", snapshot.size));

    if ($group.selected.createdByEmail) {
      $firebase
        .getUsersMeta({ createdByEmail: $group.selected.createdByEmail })
        .then(snapshot =>
          $group.selected.change("createdBy", snapshot.size ? snapshot.docs[0].id : "")
        );
    }
  }, [$group.selected, $group.selected.createdByEmail, $firebase]);

  return (
    <form name="group-edit">
      <M.Grid container spacing={4}>
        <M.Grid item md={6}>
          <M.TextField
            fullWidth
            label={"Naam"}
            key={"name"}
            value={$group.selected.name}
            onChange={e => $group.selected.change("name", e.target.value)}
          />
        </M.Grid>
        <M.Grid item md={6}>
          <M.TextField
            fullWidth
            label={"createdOn"}
            key={"createdOn"}
            value={$group.selected.createdOn}
            disabled={true}
          />
        </M.Grid>
      </M.Grid>
      <M.Grid container spacing={4}>
        <M.Grid item md={6}>
          <M.TextField
            fullWidth
            key={"createdByEmail"}
            label="Begeleider (Email)"
            value={$group.selected.createdByEmail}
            onChange={e => $group.selected.change("createdByEmail", e.target.value)}
          />
        </M.Grid>
        <M.Grid item md={6}>
          <M.TextField
            fullWidth
            required
            key={"createdBy"}
            disabled
            label="Begeleider (ID)"
            value={$group.selected.createdBy}
          />
        </M.Grid>
      </M.Grid>
      <M.Grid container spacing={4}>
        <M.Grid item md={6}>
          <M.TextField
            fullWidth
            disabled
            key={"respondentCount"}
            label="Aantal respondenten"
            value={$group.selected.totalRespondentCount}
          />
        </M.Grid>
        <M.Grid item md={6}>
          <M.TextField
            label="Onderwijsniveau"
            fullWidth
            name="educationLevel"
            select
            value={$group.selected.educationLevel || "select"}
            onChange={e => $group.selected.change("educationLevel", e.target.value)}
          >
            {[
              { label: "Basisonderwijs", value: "basis" },
              { label: "Secundair onderwijs", value: "secundair" }
            ].map((period, i) => (
              <M.MenuItem key={i} value={period.value}>
                {period.label}
              </M.MenuItem>
            ))}
          </M.TextField>
        </M.Grid>
        {$config.id === "obs-barometer" && (
          <M.Grid item md={6}>
            <M.FormControlLabel
              control={
                <M.Checkbox
                  name="brugFiguur"
                  checked={$group.selected.brugFiguur}
                  onChange={e => {
                    $group.selected.change(e.target.name, e.target.checked ? true : false);
                  }}
                />
              }
              label="BrugFiguur"
            />
          </M.Grid>
        )}
      </M.Grid>
    </form>
  );
};

export default inject("store")(observer(GroupEdit));
